// Request permission from browser
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.warn("This browser does not support notifications");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
};

// Show notification
export const showNotification = (title, body, options = {}) => {
  if (Notification.permission !== "granted") return;

  const notification = new Notification(title, {
    body,
    icon: "/irc-logo.png", // place icon in public folder
    badge: "/irc-logo.png",
    silent: false,
    ...options,
  });

  // Auto close after 5 seconds
  setTimeout(() => notification.close(), 5000);

  // Optional click action
  notification.onclick = () => {
    window.focus();
    notification.close();
  };
};
